export default __webpack_public_path__ + "images/C0.06fcb26.png";